import { MdlDialogService } from '@angular-mdl/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActionsMenuAgRendererComponent, ActionsMenuItem } from '../../covance-ag-grid';
import { CommonLinkEditorResult, CommonLinkEditorResultAction } from './common-link-editor.component';
import { CommonLinkInfo } from './common-link-info';
import { CommonLinksInfoEditor } from './common-links-editor';
import { CommonLinksInfoStorage } from './common-links-info-storage';
import { Observable } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';

@Component({
    selector: 'common-link-editor-menu-ag-renderer',
    template: require('../../covance-ag-grid/renderers/actions-menu-ag-renderer-base.html'),
    styles: [require('../../covance-ag-grid/renderers/actions-menu-ag-renderer-base.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonLinkActionsMenuAgRendererComponent extends ActionsMenuAgRendererComponent<CommonLinkInfo> {

    constructor(
        private readonly commonLinksInfoStorage: CommonLinksInfoStorage,
        private readonly mdlDialogService: MdlDialogService,
        private readonly commonLinksInfoEditor: CommonLinksInfoEditor
    ) {
        super();
    }

    public createMenuItems(commonLink: CommonLinkInfo): ActionsMenuItem[] {
        return [
            {
                title: 'Edit',
                onClick: () => this.editCommonLink(commonLink)
            },
            {
                title: 'Delete',
                onClick: () => {
                    this.deleteCommonLink(commonLink);
                }
            }
        ];
    }

    private async deleteCommonLink(commonLink: CommonLinkInfo) {
        const deleteConfirmed = await this.showDeleteDialog(commonLink);
        
        if (deleteConfirmed) {
            await this.commonLinksInfoStorage.delete(commonLink.commonLinkId);
            this.commonLinksInfoStorage.forceLoadAll();
        }
    }

    private async editCommonLink(commonLink: CommonLinkInfo) {
        const dialogResult = await this.showEditDialog(commonLink).toPromise();

        if (dialogResult.action === CommonLinkEditorResultAction.save) {
            await this.commonLinksInfoStorage.put(dialogResult.editedEntity);
            this.commonLinksInfoStorage.forceLoadAll();
        }
    }

    private async showDeleteDialog(commonLink: CommonLinkInfo): Promise<boolean> {
        try {
            await this.mdlDialogService.confirm(`The ${commonLink.title} link will be deleted. Continue?`).toPromise();
            return true;
        } catch {
            return false;
        }
    }

    private showEditDialog(commonLink: CommonLinkInfo): Observable<CommonLinkEditorResult> {
        return this.commonLinksInfoEditor.openToEdit(commonLink).pipe(
            switchMap(dialog => dialog.onHide()),
            map(dialogResult => dialogResult || { action: CommonLinkEditorResultAction.close })
        );
    }
}